module.exports = __webpack_public_path__ + "static/family-297bfb59494b8034618806049eb6a88a.png";